<template>
  <div>
    <div class="main" :class="local == 'jp' ? 'japanese' : ''">
      <!-- 0906 新增 跑馬燈 -->
      <div class="marquee-box" v-show="MarqueeData != null">
        <div class="container">
          <router-link :to="{ name: 'PushList' }" class="notify_btn" :title="$t('通知')">
            <div class="">
              <img src="img/bell.svg" alt="">
            </div>
            <p>{{ $t("通知") }}</p>
          </router-link>
          <a>
            <div class="img-box">
              <img src="img/marquee-icon.png" alt="" />
            </div>
            <div class="marquee-wrap">
              <div class="marquee-inner">
                <p>
                  <a v-for="Post in MarqueeData.Posts" :key="Post.PId" href="javascript:void(0);"
                    @click="gotoPost(Post)">{{ Post.Title }}</a>
                </p>
              </div>
            </div>
          </a>
        </div>
      </div>
      <section class="member-number" v-if="Account">
        <div class="container">
          <div class="box">
            <p>{{ $t("會員編號") }}</p>
            <p>{{ Account }}</p>
          </div>
        </div>
      </section>
      <section class="member-number" v-else>
        <div class="container">
          <div class="box">
            <p>{{ $t("會員編號") }}</p>
            <p>{{ $t("請先登入會員") }}</p>
          </div>
        </div>
      </section>
      <!-- banner -->
      <section class="banner" v-show="BannerData">
        <div class="container">
          <!-- 0518 改 class名稱 -->
          <div class="slider-for">
            <div class="box" v-for="Post in BannerData.Posts" :key="Post.PId">
              <a @click="gotoPost(Post)"><img :src="SiteUrl + Post.Image" alt="" /></a>
            </div>
          </div>
          <!-- 0518 新增 slider-nav div -->
          <div class="slider-nav">
            <div class="box" v-for="(Post, index) in BannerData.Posts" :key="Post.PId">
              {{ index + 1 }}
            </div>
          </div>
          <!-- 0518 新增 total div -->
          <div class="total">
            <p>{{ BannerData.Count }}</p>
          </div>
        </div>
      </section>
      <!-- 票券種類icon選單 -->
      <section class="ticket-type" v-show="local != 'jp'">
        <div class="container">
          <ul class="type-box">
            <!-- 0328 新增 -->
            <li class="title">
              <div>{{ $t("購買套票") }}</div>
            </li>
            <li>
              <router-link :to="{ name: 'MProductList' }">
                <img src="img/icon-month.svg" alt="" />
                <p>{{ $t("月票") }}</p>
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'SProductList' }">
                <img src="img/icon-season.svg" alt="" />
                <p>{{ $t("季票") }}</p>
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'ProductList' }">
                <img src="img/icon-time.svg" alt="" />
                <p>{{ $t("時數票") }}</p>
              </router-link>
            </li>
          </ul>
        </div>
      </section>
      <section class="ticket-type bb" v-if="local != 'jp'">
        <div class="container">
          <ul class="type-box aa">
            <li>
              <a href="javascript:void(0)" @click="gotoUrl('https://maas.foxconn.com/MaasBus/', true)">
                <img src="https://men-go.tw/Upload/FileManager/b3e93c07-b805-47d3-9315-a8f4024cf021.webp" alt="">
              </a>
            </li>
          </ul>
        </div>
      </section>
      <!-- 套票資訊/線上購買 -->
      <section class="ticket">
        <div class="container" v-if="local != 'jp' &&
          ((CardData && CardData.o_maas_pt_det && CardData.o_maas_so_mstr) ||
            Ticket)
        ">
          <!-- 套票資訊 -->
          <div class="aa" v-if="CardData && CardData.o_maas_pt_det && CardData.o_maas_pt_det.o_maas_pt_code_type == 1 &&
            CardData.o_maas_so_mstr.o_maas_so_write_yn != 1" style="z-index: 1; position: relative;">
            <p @click=" gotoPostByPId(local == 'zh_tw' ? 696 : 716)"
              style="transform: translateY(0); margin-top: -5px;">{{
                $t("月票尚未過卡，乘車將一般收費扣款。點我了解手機過卡。") }}
            </p>
          </div>
          <div class="box card-box">
            <div class="box-bg"></div>
            <div class="card-main month-main show" v-if="CardData && CardData.o_maas_pt_det && CardData.o_maas_so_mstr
            ">
              <h2>{{ CardData.o_maas_pt_det.o_maas_pt_name_zh_tw }}</h2>
              <p>
                {{ $t("套票效期") }}
                <span>
                  {{
                    timeString(
                      CardData.o_maas_so_mstr.o_maas_so_start,
                      "YYYY/MM/DD"
                    )
                  }}
                  ~
                  {{
                    timeString(
                      CardData.o_maas_so_mstr.o_maas_so_expire,
                      "YYYY/MM/DD"
                    )
                  }}
                  <router-link v-if="CardData.CanRenew" :to="{
                    name: 'MProductBuy',
                    params: { o_maas_pt_seq: CardData.CanRenewPT },
                  }" tag="button" class="renew">
                    {{ $t("續約") }}
                  </router-link>
                </span>
              </p>
              <hr
                v-if="CardData.HasYBCode && ((CardData.o_maas_so_mstr.voucher_uuid && CardData.o_maas_so_mstr.voucher_url) || (CardData.o_maas_pt_det.o_maas_pt_code_type == 2))" />
              <div class="bike-box"
                v-if="CardData.HasYBCode && ((CardData.o_maas_so_mstr.voucher_uuid && CardData.o_maas_so_mstr.voucher_url) || (CardData.o_maas_pt_det.o_maas_pt_code_type == 2))">
                <template v-if="CardData.o_maas_so_mstr.voucher_uuid && CardData.o_maas_so_mstr.voucher_url">
                  <h2>
                    {{ $t("YouBike序號") }}
                    <button style="background-color: #203242; color: white;" @click="
                      copyYouBike(
                        CardData.o_maas_so_mstr.voucher_uuid +
                        '|' +
                        CardData.o_maas_so_mstr.voucher_url
                      )
                      ">
                      {{ $t("請點我綁定") }}
                    </button>
                  </h2>
                  <template v-if="CardData.o_maas_so_mstr.AutoYBConnect && CardData.o_maas_so_mstr.AutoYBStatus == 1">
                    <h2>
                      {{ $t("系統已自動綁定YouBike") }}
                    </h2>
                  </template>
                  <template v-else>
                    <h2>
                      {{ $t("買QR票請綁定YouBike") }}
                    </h2>
                  </template>
                </template>
                <template v-else-if="CardData.o_maas_pt_det.o_maas_pt_code_type == 2">
                  <h2>
                    {{ $t("請先啟用QRCode") }}
                  </h2>
                </template>
              </div>
              <div class="bike-box" v-if="!CardData.HasYBCode">
                <h2>
                  {{ $t("未包含YouBike序號") }}
                </h2>
                <!-- <p>{{ CardData.o_maas_so_mstr.voucher_uuid }}</p> -->
                <p>{{ $t("此套票不包含公共腳踏車方案") }}</p>
              </div>
              <div class="btn-box">
                <img src="img/doll-1.svg" alt="" />
                <button v-if="false">
                  {{ $t("剩餘點數:")
                  }}{{
                    CardData.o_maas_so_mstr.o_maas_so_ret_bonus -
                    CardData.o_maas_so_mstr.o_maas_so_used_bonus
                  }}{{ $t("點") }}
                </button>
              </div>
            </div>
            <!-- 0704 新增class名稱 -->
            <div class="card-main day-main" v-if="Ticket" :class="!(CardData && CardData.o_maas_pt_det && CardData.o_maas_so_mstr)
              ? 'show'
              : ''
              ">
              <h2>{{ TicketProduct.Name }}</h2>
              <p>
                {{ $t("到期時間") }}
                <span>
                  {{ timeString(Ticket.ExpireTime, "YYYY/MM/DD HH:mm") }}
                </span>
              </p>
              <hr />
              <div class="bike-box">
                <h2>
                  {{ $t("YouBike序號") }}
                  <button @click="
                    copyYouBike(
                      Ticket.voucher_uuid + '|' + Ticket.voucher_url
                    )
                    ">
                    {{ $t("按下可複製") }}
                  </button>
                </h2>
                <!-- <p>{{ Ticket.voucher_uuid }}</p> -->
                <p>{{ $t("買QR套票，請綁定「YouBike 2.0」") }}</p>
              </div>
              <div class="btn-box">
                <img src="img/doll-1.svg" alt="" />
              </div>
            </div>
          </div>
          <!-- 0704 新增 按鈕 -->
          <!-- <div
            class="btn"
            v-if="
              CardData &&
              CardData.o_maas_pt_det &&
              CardData.o_maas_so_mstr &&
              Ticket
            "
          >
            <button class="month-btn">{{ $t("前往天數票 >") }}</button>
            <button class="day-btn show">{{ $t("前往時數票 >") }}</button>
          </div> -->
        </div>
      </section>
      <!-- 套票資訊/線上購買 -->
      <section class="ticket" v-if="local != 'jp' &&
        (!CardData || !CardData.o_maas_pt_det || !CardData.o_maas_so_mstr) &&
        !Ticket
      ">
        <div class="container">
          <!-- 線上購票 -->
          <div class="box buy-box">
            <div class="box-bg"></div>

            <div class="">
              <div class="bg">
                <div class="title-box">
                  <!-- 0517 新增 title div -->
                  <div class="title">
                    <h2>{{ $t("套票資訊 / 線上購票") }}</h2>
                    <img src="img/icon-transportation.svg" alt="" />
                  </div>
                  <!-- 0517 新增 line-box / line -->
                  <div class="line-box">
                    <div class="line"></div>
                    <div class="line"></div>
                    <div class="line"></div>
                  </div>
                </div>
                <div class="btn-box">
                  <!-- 0517 新增 line-box / line -->
                  <div class="line-box">
                    <div class="line"></div>
                    <div class="line"></div>
                    <div class="line"></div>
                    <div class="line"></div>
                    <div class="line"></div>
                    <div class="line"></div>
                    <div class="line"></div>
                    <div class="line"></div>
                    <div class="line"></div>
                    <div class="line"></div>
                    <div class="line"></div>
                    <div class="line"></div>
                    <div class="line"></div>
                    <div class="line"></div>
                  </div>
                  <router-link :to="{ name: 'MProductList' }" tag="button">
                    <img src="img/icon-star.svg" alt="" />{{ $t("立即購買") }}
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 套票資訊/線上購買(日文) -->
      <section class="ticket">
        <div class="container" v-if="local == 'jp' && Ticket">
          <!-- 套票資訊 -->
          <div class="aa" v-if="CardData && CardData.o_maas_pt_det && CardData.o_maas_pt_det.o_maas_pt_code_type == 1 &&
            CardData.o_maas_so_mstr.o_maas_so_write_yn != 1" style="z-index: 1; position: relative;">
            <p @click="gotoPostByPId(local == 'zh_tw' ? 696 : 716)"
              style="transform: translateY(0px); margin-top: -5px;">{{
                $t("月票尚未過卡，乘車將一般收費扣款。點我了解手機過卡。") }}
            </p>
          </div>
          <div class="box card-box">
            <div class="box-bg"></div>
            <!-- 0704 新增class名稱 -->
            <div class="card-main day-main show">
              <h2>{{ TicketProduct.Name }}</h2>
              <p>
                {{ $t("到期時間") }}
                <span>
                  {{ timeString(Ticket.ExpireTime, "YYYY/MM/DD HH:mm") }}
                </span>
              </p>
              <hr />
              <div class="bike-box">
                <h2>
                  {{ $t("YouBike序號") }}
                  <button @click="
                    copyYouBike(
                      Ticket.voucher_uuid + '|' + Ticket.voucher_url
                    )
                    ">
                    {{ $t("按下可複製") }}
                  </button>
                </h2>
                <!-- <p>{{ Ticket.voucher_uuid }}</p> -->
                <p>{{ $t("買QR套票，請綁定「YouBike 2.0」") }}</p>
              </div>
              <div class="btn-box">
                <img src="img/doll-1.svg" alt="" />
              </div>
            </div>
          </div>
          <!-- 0704 新增 按鈕 -->
          <!-- <div
            class="btn"
            v-if="
              CardData &&
              CardData.o_maas_pt_det &&
              CardData.o_maas_so_mstr &&
              Ticket
            "
          >
            <button class="month-btn">{{ $t("前往天數票 >") }}</button>
            <button class="day-btn show">{{ $t("前往時數票 >") }}</button>
          </div> -->
        </div>
      </section>
      <!-- 套票資訊/線上購買(日文) -->
      <section class="ticket" v-if="local == 'jp' && !Ticket">
        <div class="container">
          <div class="box buy-box">
            <div class="box-bg"></div>
            <div class="" style="height: 100%">
              <div class="bg">
                <div class="title-box">
                  <div class="title">
                    <h2>
                      <p>MeN▸Go⁺時間券</p>
                    </h2>
                    <img src="img/icon-transportation.png" alt="" />
                  </div>
                  <div class="line-box">
                    <div class="line"></div>
                    <div class="line"></div>
                    <div class="line"></div>
                  </div>
                </div>
                <div class="btn-box">
                  <router-link :to="{ name: 'ProductList' }" tag="button">
                    <img src="img/icon-star.svg" alt="" />{{ $t("立即購買") }}
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="framed">
        <div class="row">
          <!-- 網頁板 最新消息 -->
          <!-- 20230523 增加class col-8 -->
          <section class="news-box" :class="local == 'jp' ? 'col-12' : 'col-8'"
            v-if="NewsData != null && NewsData.Category != null">
            <div class="container">
              <div class="box-bg">
                <div class="box">
                  <div class="title-box">
                    <h1>{{ NewsData.Category.CategoryName }}</h1>
                    <router-link :to="{
                      name: 'Category',
                      params: { CId: NewsData.Category.CId },
                    }">MORE</router-link>
                  </div>
                  <ul class="text-box">
                    <li class="" v-for="Post in NewsData.Posts" :key="Post.PId">
                      <a href="javascript:(0)" @click="gotoPost(Post)">
                        <p class="time">
                          {{ Post.PublicStartTime | timeString("YYYY-MM-DD") }}
                        </p>
                        <p>{{ Post.Title }}</p>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
          <!-- 申請卡片 -->
          <section class="apply-card col-12 col-lg-4" v-if="local != 'jp' && CardData == null">
            <div class="container" style="height: 100%">
              <!-- 卡片資訊 -->
              <div class="bg card-box">
                <div class="bg-2"></div>
                <div class="box">
                  <div class="title-box">
                    <h1>{{ $t("卡片資料") }}</h1>
                  </div>
                  <div class="text-box">
                    <p><span>{{ $t("審核狀態：") }}</span> {{ $t("請先登入") }}</p>
                    <router-link :to="{ name: 'Login' }" tag="button">
                      {{ $t("立即登入") }} <span>></span>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!-- 申請卡片 -->
          <section class="apply-card col-12 col-lg-4" v-if="local != 'jp' && CardData != null">
            <div class="container" style="height: 100%">
              <!-- 卡片資訊 -->
              <div class="bg card-box">
                <div class="bg-2"></div>
                <div class="box">
                  <div class="title-box">
                    <h1>{{ $t("卡片資料") }}</h1>
                  </div>
                  <div class="text-box">
                    <!-- 0328 修改名稱 新增失敗和說明 -->
                    <!-- <p> <span>記　　名：</span> 成功</p> -->
                    <p v-if="CardData.o_maas_cinfo_registered == -1 ||
                      CardData.o_maas_cinfo_registered == 99
                    ">
                      <span>記　　名：</span> 處理中
                    </p>
                    <p v-if="CardData.o_maas_cinfo_registered == 1">
                      <span>記　　名：</span> 成功
                      <img src="img/icon-tick.png" alt="" />
                    </p>
                    <p v-if="CardData.o_maas_cinfo_registered == 0">
                      <span>記　　名：</span> 失敗
                      <img src="img/icon-exclamation.png" alt="" />
                    </p>
                    <p class="reason" v-if="CardData.o_maas_cinfo_registered != 0"></p>
                    <p class="reason" v-if="CardData.o_maas_cinfo_registered == 0">
                      {{ CardData.o_maas_cinfo_registered_cmmt }}
                    </p>
                    <hr />
                    <p v-if="CardData.o_maas_cinfo_stat == 9">
                      <span>{{ $t("審核狀態：") }}</span> {{ $t("審核通過") }}
                      <img src="img/icon-tick.png" alt="" />
                    </p>
                    <button v-if="CardData.o_maas_cinfo_stat == 9 &&
                      CardData.o_maas_cinfo_cso_seq == 0
                    " @click="QRCardBind">
                      {{ $t("卡片綁定") }} <span>></span>
                    </button>
                    <router-link v-if="CardData.o_maas_cinfo_stat == 9 &&
                      CardData.o_maas_cinfo_cso_seq != 0 &&
                      !CardData.NeedExtendedTime
                    " :to="{ name: 'CardInfo' }" tag="button">{{ $t("卡片資料") }} <span>></span></router-link>
                    <router-link v-if="CardData.o_maas_cinfo_stat == 9 &&
                      CardData.o_maas_cinfo_cso_seq != 0 &&
                      CardData.NeedExtendedTime
                    " :to="{ name: 'ExtendedTime' }" tag="button">{{ $t("學生卡延展") }} <span>></span></router-link>
                    <p v-if="CardData.o_maas_cinfo_stat == 10">
                      <span>{{ $t("審核狀態：") }}</span> {{ $t("延展審核中") }}
                    </p>
                    <p v-if="CardData.o_maas_cinfo_stat == 1">
                      <span>{{ $t("審核狀態：") }}</span> {{ $t("審核中") }}
                    </p>
                    <!-- 0519 新增 審核失敗的樣子 -->
                    <p v-if="CardData.o_maas_cinfo_stat == 2">
                      <span>{{ $t("審核狀態：") }}</span> {{ $t("審核失敗") }}
                      <img src="img/icon-exclamation.png" alt="" />
                    </p>
                    <p v-if="CardData.o_maas_cinfo_stat == 2" class="reason">
                      {{ CardData.o_maas_cinfo_stat_cmmt }}
                    </p>
                    <router-link v-if="CardData.o_maas_cinfo_stat == 2" :to="{ name: 'CardBind' }" tag="button">{{
                      $t("重新申請") }} <span>></span></router-link>
                    <p v-if="CardData.o_maas_cinfo_stat == -1">
                      <span>{{ $t("審核狀態：") }}</span>
                      {{ $t("尚未申請卡片綁定") }}
                    </p>
                    <router-link v-if="CardData.o_maas_cinfo_stat == -1" :to="{ name: 'CardBind' }" tag="button">
                      {{ $t("立即申請卡片綁定") }} <span>></span>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!-- 減碳量 -->
          <section class="carbon-box" v-if="local != 'jp' && CarbonReduction > 0">
            <div class="container">
              <div class="box">
                <div class="img-box">
                  <img src="img/green-tree-icon-1.png" alt="" v-if="CarbonReduction >= 100 && CarbonReduction < 500" />
                  <img src="img/green-tree-icon-2.png" alt="" v-if="CarbonReduction >= 500 && CarbonReduction < 2000" />
                  <img src="img/green-tree-icon-3.png" alt="" v-if="CarbonReduction >= 2000" />
                  <p>{{ $t("累積減碳量") }}</p>
                </div>
                <p>
                  <span>{{ CarbonReduction }}</span>kg
                </p>
              </div>
            </div>
          </section>
        </div>
        <!-- row -->
      </div>
      <div class="nav-menu-bg"></div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import VueI18n from "vue-i18n";
import Storage from "@/utils/storage.js";

Vue.use(VueAxios, axios);
Vue.use(VueI18n);

// this.$t("立即購買")
const messages = {
  zh_tw: {
    套票效期: "套票效期",
    YouBike序號: "YouBike序號",
    按下可複製: "按下可複製",
    "買QR套票，請綁定「YouBike 2.0」": "買QR套票，請綁定「YouBike 2.0」",
    未包含YouBike序號: "未包含YouBike序號",
    此套票不包含YouBike: "此套票不包含YouBike",
    "剩餘點數:": "剩餘點數:",
    點: "點",
    到期時間: "到期時間",
    "前往月票 >": "前往月票 >",
    "前往時數票 >": "前往時數票 >",
    "套票資訊 / 線上購票": "套票資訊 / 線上購票",
    立即購買: "立即購買",
    購買套票: "購買套票",
    月票: "月票",
    時數票: "時數票",
    "身分類型：": "身分類型：",
    請先登入: "請先登入",
    立即登入: "立即登入",
    "審核狀態：": "審核狀態：",
    審核通過: "審核通過",
    "購買MeN Go卡": "購買MeN Go卡",
    卡片資料: "卡片資料",
    學生效期延展: "學生效期延展",
    延展審核中: "延展審核中",
    審核中: "審核中",
    審核失敗: "審核失敗",
    重新申請: "重新申請",
    尚未申請: "尚未申請",
    立即申請: "立即申請",
    複製成功: "複製成功",
    "是否立刻前往兌換說明頁面進行兌換?": "是否立刻前往兌換說明頁面進行兌換?",
    是: "是",
    否: "否",
    "序號複製失敗, 請稍後再試一次": "序號複製失敗, 請稍後再試一次",
    關閉: "關閉",
    "身份類別：": "身份類別：",
    累積減碳量: "累積減碳量",
    一般: "一般",
    學生: "學生",
    數位學生證: "數位學生證",
    會員編號: "會員編號",
    請先登入會員: "請先登入會員",
    "月票尚未過卡，乘車將一般收費扣款。點我了解手機過卡。": "月票尚未過卡，乘車將一般收費扣款。點我了解手機過卡。",
    "系統已自動綁定YouBike": "系統已自動綁定YouBike",
    "買QR票請綁定YouBike": "買QR票請綁定YouBike",
    "請點我綁定": "請點我綁定",
    "通知": "通知",
    "季票": "季票",
  },
  en: {
    套票效期: "Pass validity",
    YouBike序號: "YouBike number",
    按下可複製: "Press to copy",
    "買QR套票，請綁定「YouBike 2.0」":
      "Please enter the number in the [YouBike 2.0] app after purchasing QR pass.",
    未包含YouBike序號: "YouBike number not included",
    此套票不包含YouBike: "This pass does not include the YouBike option.",
    "剩餘點數:": "Remaining points:",
    點: "Points",
    到期時間: "Expiration time",
    "前往月票 >": "Monthly Pass >",
    "前往時數票 >": "Hour pass >",
    "套票資訊 / 線上購票": "Pass info / Online purchase",
    立即購買: "Buy now",
    購買套票: "Buy Pass",
    月票: "Monthly Pass",
    時數票: "Hour pass",
    "身分類型：": "Type:",
    請先登入: "Please log in",
    立即登入: "Log in",
    "審核狀態：": "Application :",
    審核通過: "Approved",
    "購買MeN Go卡": "Buy MeN Go Card",
    卡片資料: "Card info",
    學生效期延展: "Extension of student card",
    延展審核中: "Extension under review",
    審核中: "During review",
    審核失敗: "Review failed",
    重新申請: "Apply again",
    尚未申請: "Yet to apply",
    立即申請: "Apply",
    複製成功: "Copied",
    "是否立刻前往兌換說明頁面進行兌換?":
      "Do you want to go to the redemption instructions page now?",
    是: "Yes",
    否: "No",
    "序號複製失敗, 請稍後再試一次":
      "Failed to copy the number, please try again.",
    關閉: "Close",
    "身份類別：": "Identity：",
    累積減碳量: "Accumulated",
    一般: "General",
    學生: "Student",
    數位學生證: "Digital Student Card",
    會員編號: "Member ID",
    請先登入會員: "Please log in to your account first",
    "月票尚未過卡，乘車將一般收費扣款。點我了解手機過卡。": "If the monthly pass plan has not been activated your card before boarding, the fare will be charged. To know more, please click here.",
    "系統已自動綁定YouBike": "YouBike serial number successfully linked to YouBike automatically.",
    "買QR票請綁定YouBike": "QR pass users, pls paste YouBike serial number into the YouBike app.",
    "請點我綁定": "Press to bind",
    "通知": "Notice",
    "季票": "Season Pass",
  },
  jp: {
    套票效期: "フリーパスの有効期間",
    YouBike序號: "YouBIke番号",
    按下可複製: "押してコピーします",
    "買QR套票，請綁定「YouBike 2.0」":
      "QRフリーパスを買い,「YouBike2.0」に紐づけてください",
    未包含YouBike序號: "未包含YouBike序號",
    此套票不包含YouBike: "此套票不包含YouBike",
    "剩餘點數:": "剩餘點數:",
    點: "點",
    到期時間: "到期時間",
    "前往月票 >": "前往月票 >",
    "前往時數票 >": "フリーパスへ",
    "套票資訊 / 線上購票": "套票資訊 / 線上購票",
    立即購買: "今すぐ購入する",
    購買套票: "購入する",
    月票: "月票",
    時數票: "フリーパス",
    "身分類型：": "身分類型：",
    請先登入: "先にログインする",
    立即登入: "今すぐログイン",
    "審核狀態：": "審核狀態：",
    審核通過: "審核通過",
    "購買MeN Go卡": "購買MeN Go卡",
    卡片資料: "卡片資料",
    學生效期延展: "學生效期延展",
    延展審核中: "延展審核中",
    審核中: "審核中",
    審核失敗: "審核失敗",
    重新申請: "重新申請",
    尚未申請: "尚未申請",
    立即申請: "立即申請",
    複製成功: "コピーに成功しました",
    "是否立刻前往兌換說明頁面進行兌換?":
      "引き換え説明ページに移動して、すぐに引き換えますか",
    是: "はい",
    否: "いいえ",
    "序號複製失敗, 請稍後再試一次": "引き換え番号のコピーに失敗しました",
    關閉: "閉じる",
    "身份類別：": "身份類別：",
    累積減碳量: "累積減碳量",
    一般: "一般",
    學生: "學生",
    數位學生證: "數位學生證",
    會員編號: "アカウント番号",
    請先登入會員: "先にログインする",
    "月票尚未過卡，乘車將一般收費扣款。點我了解手機過卡。": "If the monthly pass plan has not been activated your card before boarding, the fare will be charged. To know more, please click here.",
    "系統已自動綁定YouBike": "系統已自動綁定YouBike",
    "買QR票請綁定YouBike": "買QR票請綁定YouBike",
    "請點我綁定": "請點我綁定",
    "通知": "通知",
    "季票": "季票",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "Home",
  i18n,
  data() {
    return {
      SiteUrl: "",
      Account: "",
      CardData: {},
      Ticket: {},
      TicketProduct: {},
      MarqueeData: {},
      BannerData: {},
      NewsData: {},
      PopupData: {},
      ProductType: 0,
      CarbonReduction: 0,
      isLoaded: false,
      isMobile:
        navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        ) != null,
      ExpireMin:
        new Date().getMonth() >= 10
          ? new Date().getFullYear() + 1
          : new Date().getFullYear(),
      ExpireMax:
        new Date().getMonth() >= 10
          ? new Date().getFullYear() + 11
          : new Date().getFullYear() + 10,
      local: "zh_tw",
      IsTester: false,
    };
  },
  created: function () {
    this.reloadHomeData();
  },
  updated: function () {
    // 0808
    // $(".home .news-box .text-box").slick({
    //   dots: false,
    //   arrows: false,
    //   infinite: true,
    //   speed: 500,
    //   fade: true,
    //   cssEase: "linear",
    //   autoplay: true,
    //   autoplaySpeed: 3000,
    // });

    if ($(".slider-for").hasClass("slick-initialized")) {
      $(".slider-for").slick("unslick");
    }
    if ($(".slider-nav").hasClass("slick-initialized")) {
      $(".slider-nav").slick("unslick");
    }

    $(".slider-for").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: ".slider-nav",
    });

    $(".slider-nav").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      asNavFor: ".slider-for",
      // dots: true,
      // centerMode: true,
      // focusOnSelect: true
      autoplay: true,
      autoplaySpeed: 5000,
    });

    $(".ticket .container > .btn .day-btn").click(function () {
      $(".ticket .container > .btn .day-btn").removeClass("show");
      $(".ticket .container > .btn .month-btn").addClass("show");

      $(this)
        .parent()
        .siblings()
        .children(".ticket .card-box .month-main")
        .removeClass("show");
      $(this)
        .parent()
        .siblings()
        .children(".ticket .card-box .day-main")
        .addClass("show");
    });

    $(".ticket .container > .btn .month-btn").click(function () {
      $(".ticket .container > .btn .month-btn").removeClass("show");
      $(".ticket .container > .btn .day-btn").addClass("show");

      $(this)
        .parent()
        .siblings()
        .children(".ticket .card-box .day-main")
        .removeClass("show");
      $(this)
        .parent()
        .siblings()
        .children(".ticket .card-box .month-main")
        .addClass("show");
    });

    if (!this.isLoaded) {
      this.isLoaded = true;
      // // 網頁板首頁的最新消息 li自動輪播
      // $(".news-box .text-box").each(function () {
      //   let slideImgs = $(".news-box .text-box li"),
      //     slideImgsCount = slideImgs.length,
      //     currentIndex = 0;
      //   slideImgs.eq(currentIndex).slideDown(1000);
      //   setInterval(showNextSlide, 3000);
      //   function showNextSlide() {
      //     let nextIndex = (currentIndex + 1) % slideImgsCount;
      //     slideImgs.eq(currentIndex).fadeOut(500);
      //     slideImgs.eq(nextIndex).slideDown(1000);
      //     currentIndex = nextIndex;
      //   }
      // });
    }
  },
  mounted: function () {
    // 套Class
    $(".wrapper").addClass("home");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }
    this.local = i18n.locale;
  },
  methods: {
    timeString(time, format) {
      return moment(time).format(format || "YYYY-MM-DD, HH:mm:ss");
    },
    copyYouBike(text) {
      const texts = text.split("|");
      Storage.set("voucher_uuid", texts[0], "1d");
      Storage.set("voucher_url", texts[1], "1d");
      let that = this;
      this.$copyText(texts[0]).then(
        function (e) {
          that
            .$swal({
              heightAuto: false,
              title: that.$t("複製成功"),
              text: that.$t("是否立刻前往兌換說明頁面進行兌換?"),
              icon: "success",
              allowOutsideClick: false,
              confirmButtonText: that.$t("是"),
              showCancelButton: true,
              cancelButtonText: that.$t("否"),
            })
            .then((result) => {
              if (result.isConfirmed) {
                if (i18n.locale == "jp") {
                  that.$router.push({
                    name: "Post",
                    params: { PId: 599 },
                  });
                } else {
                  that.$router.push({
                    name: "Post",
                    params: { PId: 35 },
                  });
                }
              }
            });
        },
        function (e) {
          alert(that.$t("序號複製失敗, 請稍後再試一次"));
        }
      );
    },
    // onCopy(e) {
    //   const texts = e.text.split("|");
    //   this.$cookies.set("voucher_uuid", texts[0], "1d");
    //   this.$cookies.set("voucher_url", texts[1], "1d");
    //   this.$swal({
    //     title: this.$t("複製成功"),
    //     text: this.$t("是否立刻前往兌換說明頁面進行兌換?"),
    //     icon: "success",
    //     allowOutsideClick: false,
    //     confirmButtonText: this.$t("是"),
    //     showCancelButton: true,
    //     cancelButtonText: this.$t("否"),
    //   }).then((result) => {
    //     if (result.isConfirmed) {
    //       this.$router.push({
    //         name: "Post",
    //         params: { PId: 35 },
    //       });
    //     }
    //   });
    // },
    // onError(e) {
    //   alert(this.$t("序號複製失敗, 請稍後再試一次"));
    // },
    gotoPost(Post) {
      if (Post.Type == 1) {
        if (Post.Url != "#") {
          if (this.isMobile && typeof cordova != "undefined") {
            cordova.InAppBrowser.open(
              Post.Url,
              "_blank",
              "location=no,hardwareback=no,footer=yes,closebuttoncaption=" +
              this.$t("關閉") +
              ",closebuttoncolor=#ffffff"
            );
          } else {
            if (Post.Blank) {
              window.open(Post.Url, "_blank");
            } else {
              window.open(Post.Url);
            }
          }
        }
      } else {
        this.$router.push({
          name: "Post",
          params: { PId: Post.PId },
        });
      }
    },
    gotoPostByPId(PId) {
      this.$router.push({
        name: "Post",
        params: { PId: PId },
      });
    },
    gotoUrl(url, blank) {
      if (this.isMobile && typeof cordova != "undefined") {
        cordova.InAppBrowser.open(
          url,
          blank ? "_system" : "_blank",
          "location=no,hardwareback=no,footer=yes,closebuttoncaption=" +
          this.$t("關閉") +
          ",closebuttoncolor=#ffffff"
        );
      } else {
        if (blank) {
          window.open(url, "_blank");
        } else {
          window.open(url);
        }
      }
    },
    QRCardBind() {
      let that = this;
      that
        .$swal({
          title: that.$t("卡片綁定"),
          html:
            '<div style="margin-bottom: 10px;">' +
            '<label for="swal2-input" class="swal2-input-label">請輸入要綁定的卡片號碼</label>' +
            '<input id="cardNo" class="swal2-input" style="width: 70%">' +
            '<label for="swal2-input" class="swal2-input-label">若為數位學生證請輸入畢業年份</label>' +
            '<select id="expire" class="swal2-input" style="width: 70%">' +
            '<option value="-1">-</option>' +
            '<option value="' +
            that.ExpireMin +
            '">' +
            that.ExpireMin +
            "</option>" +
            '<option value="' +
            (that.ExpireMin + 1) +
            '">' +
            (that.ExpireMin + 1) +
            "</option>" +
            '<option value="' +
            (that.ExpireMin + 2) +
            '">' +
            (that.ExpireMin + 2) +
            "</option>" +
            '<option value="' +
            (that.ExpireMin + 3) +
            '">' +
            (that.ExpireMin + 3) +
            "</option>" +
            '<option value="' +
            (that.ExpireMin + 4) +
            '">' +
            (that.ExpireMin + 4) +
            "</option>" +
            '<option value="' +
            (that.ExpireMin + 5) +
            '">' +
            (that.ExpireMin + 5) +
            "</option>" +
            '<option value="' +
            (that.ExpireMin + 6) +
            '">' +
            (that.ExpireMin + 6) +
            "</option>" +
            '<option value="' +
            (that.ExpireMin + 7) +
            '">' +
            (that.ExpireMin + 7) +
            "</option>" +
            '<option value="' +
            (that.ExpireMin + 8) +
            '">' +
            (that.ExpireMin + 8) +
            "</option>" +
            '<option value="' +
            (that.ExpireMin + 9) +
            '">' +
            (that.ExpireMin + 9) +
            "</option>" +
            '<option value="' +
            (that.ExpireMin + 10) +
            '">' +
            (that.ExpireMin + 10) +
            "</option>" +
            "</select>" +
            '<div id="errorMsg" class="swal2-validation-message" id="swal2-validation-message" style="display: none;"></div>' +
            "</div>",
          heightAuto: false,
          showCancelButton: true,
          confirmButtonText: that.$t("確定"),
          cancelButtonText: that.$t("取消"),
          showLoaderOnConfirm: true,
          allowOutsideClick: false,
          preConfirm: () => {
            var cardNo = $("#cardNo").val();
            var expire = $("#expire").val();
            var regexNumber = /^\d{16}$/;
            if (!regexNumber.test(cardNo)) {
              $("#errorMsg").html("卡片號碼格式錯誤");
              $("#errorMsg").css("display", "flex");
              return false;
            }
            if (cardNo == "") {
              $("#errorMsg").html("請輸入要綁定的卡片號碼");
              $("#errorMsg").css("display", "flex");
              return false;
            } else if (cardNo.startsWith("15") && expire == -1) {
              $("#errorMsg").html("請輸入畢業年份");
              $("#errorMsg").css("display", "flex");
              return false;
            }
            $("#errorMsg").css("display", "none");
            return {
              cardNo: cardNo,
              expire: expire,
              token: Storage.get("ek_login_token"),
            };
          },
        })
        .then((result) => {
          if (result.isConfirmed) {
            $.ajax({
              url:
                that.GLOBAL.apiSrc +
                that.GLOBAL.subDirectory +
                "/Htmlv2/QRCardBind",
              type: "post",
              data: {
                token: result.value.token,
                cardNo: result.value.cardNo,
                expire: result.value.expire,
              },
              dataType: "json",
              error: function () {
                that.$swal({
                  heightAuto: false,
                  title: that.$t("錯誤"),
                  text: that.$t("卡片綁定過程發生錯誤, 請稍後再試一次"),
                  icon: "error",
                  allowOutsideClick: false,
                  confirmButtonText: that.$t("確定"),
                });
              },
              success: function (res) {
                that.$swal({
                  heightAuto: false,
                  title: that.$t("請稍候..."),
                  allowOutsideClick: false,
                  showConfirmButton: false,
                  willOpen: function () {
                    that.$swal.showLoading();
                  },
                });
                // 判斷結果
                if (res.ok) {
                  that.$swal({
                    heightAuto: false,
                    icon: "success",
                    title: that.$t("卡片綁定成功"),
                    confirmButtonText: that.$t("確定"),
                    willClose: function () {
                      // 重新整理畫面
                      location.reload();
                    },
                    allowOutsideClick: false,
                  });
                } else if (res.error_msg) {
                  var error_msg = JSON.parse(res.error_msg);
                  that.$swal({
                    heightAuto: false,
                    title: that.$t("錯誤"),
                    text: error_msg[i18n.locale],
                    icon: "error",
                    allowOutsideClick: false,
                    confirmButtonText: that.$t("確定"),
                  });
                }
              },
            });
          }
        });
    },
    reloadHomeData() {
      Vue.axios
        .get(this.GLOBAL.apiSrc + this.GLOBAL.subDirectory + "/Htmlv2/Home", {
          params: {
            token: Storage.get("ek_login_token"),
            lang: Storage.get("ek_site_lang"),
          },
        })
        .then((response) => {
          this.IsTester = response.data.IsTester ? response.data.IsTester : false;
          this.SiteUrl = response.data.SiteUrl;
          this.Account = response.data.Account;
          this.CardData = response.data.CardData;
          this.Ticket = response.data.Ticket;
          this.TicketProduct = response.data.TicketProduct;
          this.MarqueeData = response.data.MarqueeData;
          this.BannerData = response.data.BannerData;
          this.NewsData = response.data.NewsData;
          this.PopupData = response.data.PopupData;
          this.CarbonReduction = response.data.CarbonReduction;
          if (response.data.IsBuyLimit_QR) {
            this.$swal({
              heightAuto: false,
              title: this.$t("請注意"),
              text: response.data.BuyLimitReason_QR,
              icon: "error",
              allowOutsideClick: false,
              confirmButtonText: this.$t("確定"),
            });
          } else if (
            this.PopupData &&
            this.CardData &&
            this.CardData.o_maas_cinfo_stat == -1 &&
            !response.data.IsReadPopup
          ) {
            let that = this;
            this.$swal({
              heightAuto: false,
              title: this.PopupData.Title,
              html: this.PopupData.Text,
              allowOutsideClick: false,
              confirmButtonText: this.PopupData.UrlButtonText,
              showCancelButton: true,
              cancelButtonText: "不要再顯示此訊息",
              showDenyButton: true,
              denyButtonText: this.PopupData.CancelButtonText,
            }).then((result) => {
              console.log(result);
              if (result.isConfirmed) {
                if (that.PopupData.UrlButtonType == 0) {
                  that.$swal.close();
                } else if (that.PopupData.UrlButtonType == 1) {
                  that.$router.push({
                    name: "Category",
                    params: { CId: that.PopupData.Category },
                  });
                } else if (that.PopupData.UrlButtonType == 2) {
                  that.$router.push({
                    name: "Post",
                    params: { PId: that.PopupData.Post },
                  });
                } else if (that.PopupData.UrlButtonType == 3) {
                  that.$router.push({
                    name: that.PopupData.Url,
                  });
                }
              } else if (result.isDismissed) {
                Vue.axios.get(
                  that.GLOBAL.apiSrc +
                  that.GLOBAL.subDirectory +
                  "/Htmlv2/ReadPopup",
                  {
                    params: {
                      token: Storage.get("ek_login_token"),
                    },
                  }
                );
              }
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.marquee-wrap {
  overflow: hidden;
  width: 100%;
}

.marquee-inner {
  display: inline-block;
  white-space: nowrap;
  padding-left: 100%;
  animation: marquee-scroll 10s linear infinite;
}

.marquee-inner:hover {
  animation-play-state: paused;
}

@keyframes marquee-scroll {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-100%);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue